<template>
  С нашей системой лояльности можно получать бонусные баллы за оплату покупок и экономить до 90%!<br>
  <br>
  Для того, чтобы стать участником бонусной программы лояльности FASHIONSTORE, совершите первую покупку в интернет-магазине www.fashionstore.ru. Подробности можно узнать <router-link to="/loyalty/" target="_blank">здесь</router-link>.
</template>

<script>
export default {
  mounted() {

  },
  components: {},
  methods: {
  },
}
</script>

